import React from 'react';
import { Link } from 'react-router-dom';
import { aboutData } from '../data/aboutContent';
import ParallaxHero from '../components/ParallaxHero';

const AboutPage: React.FC = () => {
    return (
        <div className="min-h-screen">
            <ParallaxHero
                image="/assets/gallery/481680149_17850642081406413_2542156037212537063_n.jpg"
                title={aboutData.heroTitle}
                subtitle={aboutData.heroSubtitle}
                backgroundPosition="center 20%"
                backgroundSize="contain"
            />

            {/* Mission Section */}
            <section className="py-16 bg-friet-beige">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto text-center">
                        <h2 className="text-2xl md:text-3xl font-serif font-bold text-friet-red mb-6 italic">
                            {aboutData.mission.title}
                        </h2>
                        <p className="text-lg md:text-xl text-friet-red font-serif italic leading-relaxed">
                            "{aboutData.mission.content}"
                        </p>
                    </div>
                </div>
            </section>

            {/* Chef2 Photo */}
            <div className="bg-friet-beige pb-16">
                <div className="max-w-md mx-auto px-4">
                    <img
                        src="/images/gallery/overige/Sfeerbeelden/Chef/Chef2.jpg"
                        alt="FrietPlus chef"
                        className="w-full rounded-2xl shadow-xl object-cover"
                    />
                </div>
            </div>

            {/* Story Section */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto">
                        <div className="text-center mb-12">
                            <h2 className="text-3xl md:text-4xl font-serif font-bold text-friet-red mb-2 italic">
                                {aboutData.story.title}
                            </h2>
                            <p className="text-xl text-friet-red font-serif font-semibold italic">
                                {aboutData.story.subtitle}
                            </p>
                        </div>
                        <div className="space-y-6 mb-12">
                            {aboutData.story.content.map((paragraph, index) => (
                                <p key={index} className="text-lg text-friet-red font-serif italic leading-relaxed">
                                    {paragraph}
                                </p>
                            ))}
                        </div>

                        <div className="max-w-md mx-auto">
                            <img
                                src="/images/gallery/overige/Verbergen/Kids.jpg"
                                alt="FrietPlus - Kids"
                                className="w-full rounded-2xl shadow-xl object-cover"
                            />
                        </div>

                    </div>
                </div>
            </section>

            {/* Repeated Mission Section at Bottom */}
            <section className="py-16 bg-friet-beige">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto text-center">
                        <div className="w-24 h-1 bg-friet-red mx-auto mb-8 rounded-full"></div>
                        <h2 className="text-2xl md:text-3xl font-serif font-bold text-friet-red mb-6 italic">
                            Foodtruck Frietplus
                        </h2>
                        <p className="text-lg md:text-xl text-friet-red font-serif italic leading-relaxed mb-8">
                            "Onze foodtruck is voorzien van meerdere frietketels en voldoende werkruimte. Hierdoor is de foodtruck geschikt voor een intiem feest maar ook ruim genoeg om grote groepen te voorzien van lekker eten."
                        </p>
                        <div className="grid grid-cols-2 gap-4 mb-10 max-w-4xl mx-auto">
                            <img
                                src="/images/gallery/overige/Foodtruck/Foodtruck1.jpg"
                                alt="FrietPlus Foodtruck"
                                className="w-full rounded-xl shadow-lg object-contain"
                            />
                            <img
                                src="/images/gallery/overige/Foodtruck/Foodtruck2.jpg"
                                alt="FrietPlus Foodtruck"
                                className="w-full rounded-xl shadow-lg object-contain"
                            />
                        </div>
                        <div className="flex flex-col items-center gap-8">
                            <img src="/images/logonav.png" alt="Frietplus Logo" className="h-24 md:h-32 object-contain" />
                        </div>

                        {/* CTA Block moved below Foodtruck section */}
                        <div className="text-center pt-12 mt-8 border-t border-friet-red/20">
                            <p className="text-xl md:text-2xl text-friet-red font-serif mb-8 italic">
                                Getriggerd om samen met Frietplus een onvergetelijke eetervaring te beleven?
                            </p>
                            <div className="flex flex-wrap justify-center gap-4">
                                <Link
                                    to="/private-parties#contact-formulier"
                                    className="bg-friet-red text-white px-8 py-3 rounded-full font-serif font-semibold hover:bg-friet-gold hover:text-friet-black transition-colors italic"
                                >
                                    Neem Contact Op
                                </Link>
                                <Link
                                    to="/private-parties#contact-formulier"
                                    className="bg-friet-red text-white px-8 py-3 rounded-full font-serif font-semibold hover:bg-friet-gold hover:text-friet-black transition-colors italic"
                                >
                                    Vraag Offerte
                                </Link>
                                <Link
                                    to="/weddings#section-plus"
                                    className="bg-friet-red text-white px-8 py-3 rounded-full font-serif font-semibold hover:bg-friet-gold hover:text-friet-black transition-colors italic"
                                >
                                    Bekijk Menu
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutPage;
